import { FormattedMessage as FM } from "react-intl";

import HotelInput from "./HotelInput";
import HotelTimeRange from "./HotelTimeRange";
import ImageUrlField from "./ImageUrlField";
import ListEditor from "./ListEditor";
import SheetCard from "./SheetCard";
import {
  HOTEL_SCHEDULES,
  HOTEL_SERVICE_LISTS,
  IMAGE_SIZE_BANNER,
  LIST_GALLERY,
  STYLE_HOTEL_INPUT,
} from "../constants";

function HotelSheet({ form, defaults, melhousId, onChange }) {
  const fieldProps = { form, defaults, onChange };
  return (
    <div className="space-y-4">
      <SheetCard title="melhous.dash.hotel.data">
        <div className="space-y-3">
          <HotelInput {...fieldProps} name="title" />
          <ImageUrlField
            label="melhous.banner"
            value={form.banner}
            fallback={defaults.banner}
            size={IMAGE_SIZE_BANNER}
            onChange={(value) => onChange("banner", value)}
          />
          <label className="block">
            <span className="mb-1 block text-sm text-neutral-500">
              <FM id="melhous.desc" />
            </span>
            <textarea
              rows={3}
              value={form.desc}
              onChange={(event) => onChange("desc", event.target.value)}
              className={STYLE_HOTEL_INPUT}
            />
          </label>
        </div>
      </SheetCard>
      <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
        <SheetCard title="melhous.dash.hotel.contact">
          <div className="space-y-3">
            <HotelInput {...fieldProps} name="address" />
            <HotelInput {...fieldProps} name="phone" />
            <HotelInput {...fieldProps} name="reception_phone" />
            <HotelInput {...fieldProps} name="reception_phone2" />
            <HotelInput {...fieldProps} name="reception_phone3" />
            <HotelInput {...fieldProps} name="url" />
          </div>
        </SheetCard>
        <SheetCard title="melhous.dash.hotel.schedules">
          <div className="space-y-3">
            <div className="grid grid-cols-2 gap-3">
              <HotelInput {...fieldProps} name="check_in" type="time" />
              <HotelInput {...fieldProps} name="check_out" type="time" />
            </div>
            {HOTEL_SCHEDULES.map((item) => (
              <HotelTimeRange key={item.start} item={item} fieldProps={fieldProps} />
            ))}
          </div>
        </SheetCard>
        <SheetCard title="melhous.dash.hotel.wifi">
          <div className="space-y-3">
            <HotelInput {...fieldProps} name="wifi" />
            <HotelInput {...fieldProps} name="wifi_pass" />
          </div>
        </SheetCard>
      </div>
      <SheetCard title="melhous.services">
        <div className="space-y-6">
          {HOTEL_SERVICE_LISTS.map((config) => (
            <ListEditor key={config.id} config={config} parentId={melhousId} />
          ))}
        </div>
      </SheetCard>
      <SheetCard title="melhous.gallery_areas">
        <ListEditor config={LIST_GALLERY} parentId={melhousId} />
      </SheetCard>
    </div>
  );
}

export default HotelSheet;
